import { Injectable } from '@angular/core';
import { BaseApiDataService } from 'app/core/storage/base-api-data.service';
import { Observable } from 'rxjs';
import { environment } from '~env';
import { SecondaryWorkAdressToAdd } from './models/member-secondary-work-address.model';

const API_URL = environment.registrarCommandApi;

@Injectable({
  providedIn: 'root',
})
export class MemberSecondaryWorkAddressCommandService {
  constructor(private dataService: BaseApiDataService<any>) { }

  addSecondaryWorkAdress(memberId: string, data: SecondaryWorkAdressToAdd) {
    return this.dataService.post(`${API_URL}/member/${memberId}/work-address/register-secondary`, data);
  }

  removeSecondaryWorkAddress(memberId: string, workAddressId: string, effectiveUntil: Date,
    confirmDeleteDomicileProfessionel?: boolean, domicileProfessionelToDeleteId?: string) {
    return this.dataService.post(
      `${API_URL}/member/${memberId}/work-address/${workAddressId}/remove`,
      { effectiveUntil, confirmDeleteDomicileProfessionel, domicileProfessionelToDeleteId },
    );
  }

  cancelSecondaryWorkAddress(memberId: string, workAddressId: string, effectiveUntil: Date,
    confirmDeleteDomicileProfessionel?: boolean, domicileProfessionelToDeleteId?: string) {
    return this.dataService.post(
      `${API_URL}/member/${memberId}/work-address/${workAddressId}/cancel`,
      { effectiveUntil, confirmDeleteDomicileProfessionel, domicileProfessionelToDeleteId },
    );
  }

  defineWorkAddressAsMainPracticePlace(memberId: string, workAddressId: string, startingOn: Date) {
    return this.dataService.post(`${API_URL}/member/${memberId}/professional-domicile/define`, {
      workAddressId,
      effectiveOn: startingOn,
    });
  }

  correctSecondaryWorkAdress(memberId: string, workAddressId: string, data: any) {
    return this.dataService.post(`${API_URL}/member/${memberId}/work-address/${workAddressId}/correct-information`, data);
  }

  correctWorkAddressEndDate(memberId: string, workAddressId: string, effectiveUntil: Date) {
    return this.dataService.post(
      `${API_URL}/member/${memberId}/work-address/${workAddressId}/correct-end-date`,
      { effectiveUntil },
    );
  }

  cancelWorkAddressEndDate(memberId: string, workAddressId: string, effectiveUntil: Date) {
    return this.dataService.post(
      `${API_URL}/member/${memberId}/work-address/${workAddressId}/cancel-end-date`,
      { effectiveUntil },
    );
  }

  correctWorkAddressStartDate(memberId: string, workAddressId: string, effectiveOn: Date) {
    return this.dataService.post(
      `${API_URL}/member/${memberId}/work-address/${workAddressId}/correct-start-date`,
      { effectiveDay: effectiveOn.toISOString() },
    );
  }

  cancelFutureProfessionalDomicile(memberId: string, professionalDomicileId: string, effectiveOn: Date): Observable<void> {
    return this.dataService.post(`${API_URL}/member/${memberId}/professional-domicile/${professionalDomicileId}/cancel`, {
      effectiveOn: effectiveOn.toISOString(),
    });
  }

}
